import { Form, Formik } from 'formik';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { useEffect, useRef, useState } from 'react';
import { msgTypes } from 'constants/msgTypes';
import { FinancialProtectionModel } from 'model/screensModels/FinancialProtectionModel';
import { FinancialProtectionService } from 'services/menu/financialProtection/FinancialProtectionService';
import { FinancialProtectionSchema } from 'schemas/menu/financialProtection/FinancialProtectionSchema';

export const CreateFinancialProtection = ({setFlag, updateRecord, loadRecentGuideline}) => {
    const [viewMode, setViewMode] = useState(false);
    const [initialValue, setInitialValue] = useState(new FinancialProtectionModel());
    const formikRef = useRef(null);
    const fileInputRef = useRef(null);
  
    const onSubmit = async (values: FinancialProtectionModel) => {
        addFinancial(values)
    }
  
    useEffect(() => {
      if (updateRecord) {
        setInitialValue(updateRecord)
      }
    }, [updateRecord])
  
    //Prepare Data for API
    const prepareRequestBody = async (values: FinancialProtectionModel) => {
      const prepareData = new FinancialProtectionModel();
  
      //to assing id based on action
      if ((initialValue.financialProtectionId)?.length > 0) {
        prepareData.financialProtectionId = initialValue.financialProtectionId;
      } else {
        prepareData.financialProtectionId = values.financialProtectionId ? values.financialProtectionId : '';
      }
  
      prepareData.financialProtectionMessage = values.financialProtectionMessage ? values.financialProtectionMessage : '';
      prepareData.attachment = values.attachment ? values.attachment : '';
      prepareData.financialProtectionHeading = values.financialProtectionHeading ? values.financialProtectionHeading : '';

  
      return prepareData;
    }
  
    const addFinancial = async (values: FinancialProtectionModel) => {
      const requestData = await prepareRequestBody(values);
      const res = await FinancialProtectionService.addFinancialProtection(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        setInitialValue(new FinancialProtectionModel());
        loadRecentGuideline();
        formikRef.current.resetForm();
        formikRef.current.setFieldValue('imageFile', null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    };



  return (
    <>
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={FinancialProtectionSchema}
      onSubmit={onSubmit}
      innerRef={formikRef}
    >

      {
        ({ isValid, dirty, isSubmitting, values }) => (
          <Form>
            <div className="container">
              <div className="row">
                  <div className="col-lg-12 col-md-12 position-relative">
                  <FormikControl
                    control='textfield'
                    name="financialProtectionHeading"
                    label="Heading"
                    placeholder="Enter heading"
                    disabled={viewMode}
                    requiredField
                  />
                </div>

                <div className="col-lg-12 col-md-12 position-relative">
                  <FormikControl control='textfield'
                    name='financialProtectionMessage'
                    label="Financial Protection Message"
                    placeholder="Enter Financial Protection Guidelines"
                    requiredField
                    multiline
                    disabled={viewMode}
                    rows={10}
                    
                  />
                </div>
                <div className="col-lg-12 col-md-12 position-relative">
                   <FormikControl control='uploadImage'
                      requiredField
                      name="attachmentFile"
                      label="Upload Guideline"
                      tooltip = {[msgTypes.DOCUMENT_TYPE.PDF,msgTypes.DOCUMENT_TYPE.JPG, 
                        msgTypes.DOCUMENT_TYPE.JPEG,msgTypes.DOCUMENT_TYPE.PNG, msgTypes.FILE_SIZE_ALLOW_3MB]}
                      nameUrl="attachment"
                      disabled={viewMode}
                      inputRef={fileInputRef}
                    />
                </div>

              
                {!viewMode ? (
                  <div className='col-12 d-flex justify-content-end mt-4'>
                    <FormikControl control='button' className="btn btn-submit" color="primary" label={values.financialProtectionId ? 'Update' : 'Save'} disabled={!dirty || !isValid || isSubmitting} />&nbsp;&nbsp;
                    <FormikControl control='button' className="btn btn-cancel" color="warning" label="Back" type="reset" onClick={() => { setFlag(false) }} />
                  </div>
                ) : null}
              </div>
            </div>
          </Form>
        )
      }
    </Formik>
  </>
  )
}
